/* Magnetik accessory pages.
 *
 * Same commerce rules as the power bank page: add to cart posts to
 * /cart/add.js and every money string is rendered by Liquid -- this file only
 * swaps between strings Shopify already produced.
 *
 * Kept separate from magnetik-shop.js on purpose. That file carries the bundle
 * tiers and per-unit colour pickers, none of which apply to an accessory, and
 * bending it to cover both would put the power bank page at risk for no gain.
 */
(function () {
  'use strict';

  var pdp = document.getElementById('pdp');
  if (!pdp || !pdp.classList.contains('pdp-accessory')) return;

  var form     = document.getElementById('product-form');
  var idSelect = document.getElementById('variant-id');
  var qtyInput = document.getElementById('qty');
  var atc      = document.getElementById('atc');
  var atcText  = document.getElementById('atc-text');
  var note     = document.getElementById('atc-note');
  var priceEl  = document.getElementById('price');
  var mainImgs = [].slice.call(document.querySelectorAll('#gal-main img'));
  var thumbs   = [].slice.call(document.querySelectorAll('#gal-thumbs button'));

  var at = 0;

  /* ---------------- gallery ---------------- */

  /* Dots, shown only on small screens by CSS, so the desktop thumbnail strip
     is unaffected. */
  var dotsWrap = null;
  (function buildDots() {
    var galEl = document.querySelector('.gal');
    if (!galEl || mainImgs.length < 2) return;
    dotsWrap = document.createElement('div');
    dotsWrap.className = 'gal-dots';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Product images');
    mainImgs.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () { showSlide(i); });
      dotsWrap.appendChild(b);
    });
    var main = document.getElementById('gal-main');
    if (main && main.parentNode) main.parentNode.insertBefore(dotsWrap, main.nextSibling);
  })();

  /* Slides after the first ship with data-src so they do not compete with the
     LCP image. Promote them once the first is done, or immediately on any
     interaction, so a slide is never blank. */
  var hydrated = false;
  function hydrateSlides() {
    if (hydrated) return;
    hydrated = true;
    mainImgs.forEach(function (img) {
      var ds = img.getAttribute('data-src');
      if (!ds) return;
      var dss = img.getAttribute('data-srcset');
      if (dss) { img.setAttribute('srcset', dss); img.removeAttribute('data-srcset'); }
      img.setAttribute('src', ds);
      img.removeAttribute('data-src');
    });
  }
  (function scheduleHydrate() {
    var first = mainImgs[0];
    if (!first) return;
    if (first.complete) { hydrateSlides(); return; }
    first.addEventListener('load', hydrateSlides, { once: true });
    first.addEventListener('error', hydrateSlides, { once: true });
    window.addEventListener('load', hydrateSlides, { once: true });
  })();

  function showSlide(n) {
    if (!mainImgs.length) return;
    hydrateSlides();
    at = (n + mainImgs.length) % mainImgs.length;
    for (var i = 0; i < mainImgs.length; i++) mainImgs[i].classList.toggle('on', i === at);
    for (var j = 0; j < thumbs.length; j++) thumbs[j].setAttribute('aria-current', j === at ? 'true' : 'false');
    if (dotsWrap) {
      var ds = dotsWrap.children;
      for (var k = 0; k < ds.length; k++) ds[k].setAttribute('aria-current', k === at ? 'true' : 'false');
    }
  }
  thumbs.forEach(function (b, n) { b.addEventListener('click', function () { showSlide(n); }); });

  var prev = document.getElementById('gal-prev');
  var next = document.getElementById('gal-next');
  if (prev) prev.addEventListener('click', function () { showSlide(at - 1); });
  if (next) next.addEventListener('click', function () { showSlide(at + 1); });

  var gal = document.getElementById('gal-main');
  if (gal) {
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); showSlide(at - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(at + 1); }
    });
    var x0 = null;
    gal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    gal.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) showSlide(at + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  function showMedia(id) {
    if (!id) return false;
    for (var i = 0; i < mainImgs.length; i++) {
      if (mainImgs[i].getAttribute('data-media-id') === String(id)) { showSlide(i); return true; }
    }
    return false;
  }

  /* ---------------- options -> real variant ----------------
     Handles both control types the section can emit: chip groups for a handful
     of values, and a native select once there are more than eight (the case
     has 24 iPhone models). */

  var groups = [].slice.call(pdp.querySelectorAll('[data-option-position]'));

  function selectedOptions() {
    var picked = {};
    groups.forEach(function (g) {
      var pos = g.getAttribute('data-option-position');
      if (g.tagName === 'SELECT') {
        picked[pos] = g.value;
      } else {
        var on = g.querySelector('[aria-checked="true"]');
        if (on) picked[pos] = on.getAttribute('data-option-value');
      }
    });
    return picked;
  }

  function syncVariant() {
    var picked = selectedOptions();
    var opts = idSelect.options;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i], ok = true;
      for (var pos in picked) {
        if (!Object.prototype.hasOwnProperty.call(picked, pos)) continue;
        if (o.getAttribute('data-o' + pos) !== picked[pos]) { ok = false; break; }
      }
      if (!ok) continue;

      idSelect.selectedIndex = i;
      showMedia(o.getAttribute('data-media'));

      /* Price comes from the option's Liquid-rendered string, never from
         arithmetic here, so per-variant pricing stays Shopify's. */
      var p = o.getAttribute('data-price');
      if (priceEl && p) priceEl.innerHTML = p;

      var avail = !o.disabled;
      atc.disabled = !avail;
      atcText.textContent = avail ? 'Add to cart' : 'Sold out';
      return;
    }
    /* No variant matches this combination. */
    atc.disabled = true;
    atcText.textContent = 'Unavailable';
  }

  groups.forEach(function (group) {
    if (group.tagName === 'SELECT') {
      group.addEventListener('change', function () {
        var lbl = group.previousElementSibling;
        if (lbl && lbl.classList.contains('opt-label')) {
          var b = lbl.querySelector('b');
          if (b) b.textContent = group.value;
        }
        syncVariant();
      });
      return;
    }

    var choices = [].slice.call(group.querySelectorAll('[data-option-value]'));
    choices.forEach(function (btn) {
      function pick() {
        choices.forEach(function (c) { c.setAttribute('aria-checked', 'false'); c.removeAttribute('data-on'); });
        btn.setAttribute('aria-checked', 'true');
        btn.setAttribute('data-on', '1');
        var lbl = group.previousElementSibling;
        if (lbl && lbl.classList.contains('opt-label')) {
          var b = lbl.querySelector('b');
          if (b) b.textContent = btn.getAttribute('data-option-value');
        }
        syncVariant();
      }
      btn.addEventListener('click', pick);
      btn.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(); }
      });
    });
  });

  /* ---------------- cart count ---------------- */
  function refreshCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var els = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = c.item_count;
          els[i].setAttribute('data-empty', c.item_count === 0 ? 'true' : 'false');
        }
        return c;
      })
      .catch(function () {});
  }

  /* ---------------- add to cart ---------------- */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled) return;
      atc.disabled = true;
      atcText.textContent = 'Adding...';
      if (note) { note.textContent = ''; note.classList.remove('err'); }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(idSelect.value), quantity: parseInt(qtyInput.value, 10) || 1 }]
        })
      })
        .then(function (res) {
          return res.json().then(function (d) {
            if (!res.ok) throw new Error(d.description || d.message || 'Could not add to cart');
            return d;
          });
        })
        .then(function () {
          /* Same drawer as the power bank page, on every screen size. */
          if (window.MagnetikDrawer) {
            return window.MagnetikDrawer.refresh().then(function () {
              window.MagnetikDrawer.open();
            });
          }
          return refreshCount();
        })
        .then(function () {
          atc.disabled = false;
          atcText.textContent = 'Add to cart';
        })
        .catch(function (err) {
          atc.disabled = false;
          atcText.textContent = 'Add to cart';
          if (note) { note.textContent = err.message || 'Something went wrong.'; note.classList.add('err'); }
        });
    });
  }

  refreshCount();
})();
